<div class="switch" [ngClass]="{ checked: value, disabled: isDisabled }" (click)="toggle()">
    <div class="switch-inner"></div>
    <div class="switch-toggler"></div>
</div>
